import Modal from "../_bootstrapModalExtensions";
import * as Url from "../Utils/UrlUtil";
import * as PleaseWaitModal from "../Utils/PleaseWaitModal";

export function OnMassTransferListInit(s: ASPxClientGridView, e: ASPxClientEventArgs) {
    $.ajax({
        url: window.ETDR_RD.appConfig["UrlAction.MassTransferHealthCheck"],
        method: "POST",
        success: function (data: any, testStatus: JQuery.Ajax.SuccessTextStatus, jqXHR: JQuery.jqXHR) {
            let hasError: boolean = false;

            data.forEach(function (i) {
                if (i.hasDefiniteError || i.timeoutExpired) {
                    hasError = true;

                    $('#mt-alert-' + i.headerId).show();
                }
            });

            if (hasError) {
                $('#masstransfer-error-placeholder').show();
            }
        },
        error: function (jqXHR: JQuery.jqXHR, textStatus: JQuery.Ajax.ErrorTextStatus, errorThrown: string) {
            // Error?!?!
            // This function is only supposed to report issues with certain items, but otherwise does not disturb the user (the user should not know this function even exists)
            // Doing anything other than silently reporting the error would be too intrusive, so do nothing (sorry!)
            console.log(textStatus + ': ' + errorThrown)
        }
    });
}

export function AfterLoadedMassTransferItems(MassTransferDetailsList: ASPxClientGridView, e: ASPxClientEventArgs) {
    let rowCount = MassTransferDetailsList.GetVisibleRowsOnPage();
    if (rowCount === 0) {
        $("#start-mass-transfer").addClass("disabled");
    }
    else {
        $("#start-mass-transfer").removeClass("disabled");
    }
}

export function checkAndConfirmMassTransfer(headerId: number) {
    Modal.showConfirmationWindowAsync(
        'Véglegesítést követően már nem módosíthat a csomagon, az áttétel megkezdődik.\nBiztosan véglegesíti?',
        'Figyelem',
        function () {
            // Once the process is started, the operation buttons should be hidden and the "in progress" message should be shown
            $("#operations").hide();
            $('#info-bar-processing').show();

            $.ajax({
                method: "POST",
                url: window.ETDR_RD.appConfig["UrlAction.MassTransferStart"],
                data: {
                    'headerId': headerId
                },
                success: function (data) {
                    $('#info-bar-processing').hide();

                    if (data.Success) {
                        $('#info-bar-success').show();

                        // Just force a refresh on the list. The user will most likely not see any state change.
                        let grid = window['MassTransferDetailsList'] as ASPxClientGridView;
                        grid.Refresh();
                    } else {
                        $('#info-bar-error').show();
                    }
                },
                error: function (request, status, error) {
                    // Something went wrong, no answer or bad answer from the server
                    // Let's show the generic error on this page, namely that the operation was unsuccessful
                    $('#info-bar-error').show();
                    console.log('Error: ' + error);
                }
            });

        },
        function () { return false; },
        'OK',
        'Mégsem'
    );
}

export function OnRowClickMassTransfer(s: ASPxClientGridView, e) {
    if (!e.htmlEvent.target.classList.contains("dxgvCommandColumn")) {
        PleaseWaitModal.Show();
        var key = s.GetRowKey(e.visibleIndex);
        location.href = Url.createUrlFromTemplate(window.ETDR_RD.appConfig["UrlTemplate.MassTransferDetailsListEdit"], { headerId: key });
    }
}

export function OnRowClickMassTransferIncoming(s: ASPxClientGridView, e) {
    if (!e.htmlEvent.target.classList.contains("dxgvCommandColumn")) {
        PleaseWaitModal.Show();
        var key = s.GetRowKey(e.visibleIndex);
        location.href = Url.createUrlFromTemplate(window.ETDR_RD.appConfig["UrlTemplate.MassTransferIncomingDetailsList"], { headerId: key });
    }
}

export function OnSelectionChangedInMassTransferProcessListSelect(s: ASPxClientGridView, e: ASPxClientGridViewSelectionEventArgs) {
    if (s.GetSelectedRowCount() > 0) {
        $('#btn-mt-submit').removeClass("disabled");
    } else {
        $('#btn-mt-submit').addClass("disabled");
    }
}

export function AddSelectedItemsToMassTransferHeader(ProcessListForMassTransfer: ASPxClientGridView) {
    $('#btn-mt-submit').addClass("disabled");

    try {
        PleaseWaitModal.Show();
        ProcessListForMassTransfer.GetSelectedFieldValues("PadoId", (items: number[]) => {
            var selectedItemIds = items.join();
            var $btn = $("#btn-mt-submit");

            $.ajax({
                method: "POST",
                url: window.ETDR_RD.appConfig["UrlAction.MassTransferAddItemsToDetailsList"],
                data: {
                    'headerId': $btn.data('header-id'),
                    'selectedIds': selectedItemIds,
                },
                success: function (data) {
                    location.href = $btn.data('onsuccess-url');
                },
                error: function (request, status, error) {
                    // Network error or http error (e.g.: 500 - internal server error) (maybe the session expired?)
                    // Not much we can do on the client side, just show the user some generic error
                    $('#error-mt-submit-for-processing').show();
                    console.log('Error: ' + error);
                    PleaseWaitModal.Hide();
                }
            });
        });
    } catch (e) {
        PleaseWaitModal.Hide();
    }
}

export function OnSelectionChangedInMassTransferDetails(s: ASPxClientGridView, e: ASPxClientGridViewSelectionEventArgs) {
    if (s.GetSelectedRowCount() > 0) {
        $('#delete-mass-transfer-detail-btn').removeClass("disabled");
    } else {
        $('#delete-mass-transfer-detail-btn').addClass("disabled");
    }
}

export function DeleteSelectedItemsFromMassTransferDetail(headerId, MassTransferDetailsList: ASPxClientGridView) {
    $('#delete-mass-transfer-detail-btn').addClass("disabled");

    try {
        PleaseWaitModal.Show();

        MassTransferDetailsList.GetSelectedFieldValues("PadoId", (items: number[]) => {
            try {
                $.ajax({
                    method: "POST",
                    url: window.ETDR_RD.appConfig["UrlAction.DeleteItemsFromMassTransferDetailsList"],
                    data: {
                        'headerId': headerId,
                        'selectedIds': items,
                    },
                    success: function (data) {
                        MassTransferDetailsList.Refresh();
                    },
                    error: function (request, status, error) {
                        // Network error orhttp error (e.g.: 500 - internal server error) (maybe the session expired?)
                        // Not much we can do on the client side, just show the user some generic error
                        $('#error-mt-submit-for-processing').show();
                        console.log('Error: ' + error);
                    },
                    complete: function () {
                        $('#delete-mass-transfer-detail-btn').removeClass("disabled");
                        PleaseWaitModal.Hide();
                    }
                });
            } catch {
                PleaseWaitModal.Hide();
            }
        });
    } catch (e) {
        PleaseWaitModal.Hide();
    }
}

export function DeleteMassTransferHeader(grid: ASPxClientGridView) {
    let headerId = grid.GetSelectedKeysOnPage()[0];

    $.getJSON(window.ETDR_RD.appConfig["UrlAction.MassTransferCheckDeleteHeader"], { headerId: headerId }, function (data: string) {

        var resultOk: boolean = false;

        if (data === 'state') {
            Modal.showAlertWindow(
                'A kiválasztott áttétel nem törölhető, mert véglegesített vagy éppen feldolgozás alatt van!',
                ''
            );
        }

        if (data === 'items') {
            Modal.showConfirmationWindowAsync(
                'A törlendő csomagnak vannak tételei, így a tételek is törlésre kerülnek. Biztosan szeretné törölni?',
                'Figyelem',
                function () { deleteHeader(); },
                function () { return false; },
                'Igen',
                'Nem'
            );
        }

        if (data === 'erasable') {
            Modal.showConfirmationWindowAsync(
                'Biztosan törli az elemet?',
                'Figyelem',
                function () { deleteHeader(); },
                function () { return false; },
                'Igen',
                'Nem'
            );
        }

        function deleteHeader() {
            $.ajax({
                method: "POST",
                url: window.ETDR_RD.appConfig["UrlAction.MassTransferDeleteSelectedHeader"],
                data: { 'id': headerId },
                complete: function () { grid.Refresh(); }
            });
        }
    });
}

export function EditMassTransferHeader(grid: MVCxClientGridView) {

    // We would like to edit the header currently selected on the page
    // Conviently, only one item is selectable
    let selectedKeys = grid.GetSelectedKeysOnPage();

    // Just make sure something is REALLY selected (the button should be disabled to avoid this, just a sanity check)
    if (selectedKeys && selectedKeys.length > 0) {
        // Okay, this is the selected one
        let selectedKey = selectedKeys[0];

        // Only rows with a certain state are editable, make sure the current one is just that
        let state = $(`#state-of-header-${selectedKey}`).val();

        if (state === window.ETDR_RD.appConfig["Constants.EditableMassTransferHeaderState"]) {
            // Everything is GUCCI, let's navigate to the edit page
            let url = Url.createUrlFromTemplate(window.ETDR_RD.appConfig["UrlTemplate.MassTransferEditHeader"], { headerId: selectedKey });
            location.href = url;
        }
    }
}

export function UpdateMassTransferHeaderButtonsDisabledState(grid: MVCxClientGridView, e: ASPxClientGridViewSelectionEventArgs) {
    // If something is selected, we need to run some checks to make sure the selected row is actually editable
    if (e.isSelected) {
        let selectedKeys = grid.GetSelectedKeysOnPage();

        if (selectedKeys && selectedKeys.length > 0) {
            // Okay, this is the selected one
            let selectedKey = selectedKeys[0];

            // The row state is saved in a hidden field, get it
            let state = $(`#state-of-header-${selectedKey}`).val();

            if (state && state === window.ETDR_RD.appConfig["Constants.EditableMassTransferHeaderState"]) {
                $("#editHeaderButton").removeAttr("disabled");
                $("#deleteHeaderButton").removeAttr("disabled");

                return;
            }
        }
    }

    $("#editHeaderButton").attr("disabled", "disabled");
    $("#deleteHeaderButton").attr("disabled", "disabled");
}

// To submit the selected item in the DX table, we need to save it in a form element
// - targetSelector defines the hidden field where the selected item's id should be saved
export function OnDetailsListSelectionChanged(s: MVCxClientGridView, e: ASPxClientGridViewSelectionEventArgs, targetSelector: String) {
    if (e.visibleIndex > -1) {
        var target = $(targetSelector);

        // This only shows the selected keys (with endless pading, not all rows are visible)
        // The selected item is always put on the first page, so it is not possible that something is selected, but not visible on the interface)
        let selectedId = s.GetSelectedKeysOnPage();
        target.val(selectedId[0].toString());
    }
}
